module.exports = __webpack_public_path__ + "img/taiyo_cursor_hover.85325381.png";